export default "__VITE_ASSET__CmJQtIqg__"